<div class="auth-container" style="background: url('assets/images/pic-picture.jpeg') no-repeat center center fixed; background-size: cover;">
    <!-- Main content area -->
<main class="container"  style="max-height: 99vh; overflow-y: auto;">
    <br>
    <section class="page-body">
        <!-- existing form content should be inserted by the component -->
        <ng-content>
            <div class="container">
                <div class="row">
                    <div class="card" style="min-height: 80vh;" role="region" aria-label="Application form">
                            <section aria-labelledby="supportingDocumentsHeading" style="margin: 1rem;">
                                
                                <div class="controls" >
                                    <div class="left">
                                        <div style="display: flex; justify-content: center; margin-bottom: 6px;">
                                            <img src="assets/images/PIC- logo-small.png" alt="PIC Logo" height="80" class="d-inline-block align-text-top" >
                                        </div>
                                    </div>
                                    <div class="right">
                                        
                                    </div>
                                </div>
                                <h5 class="form-heading">PIC Client Portal Terms of Use</h5><br>

                                <div class="row">
                                    <div class="col" style="text-align: justify;">
                                        <p>The PIC Client Portal is a platform that aims to improve PIC’s service offering to clients and strengthen communication and relationship with clients. The PIC is committed to protecting its reputation, that of all its clients and employees against illegal or damaging actions committed by individuals whether knowingly or unknowingly. The Client Portal Terms of Use listed below aim to give effect to this stated commitment.</p>
                                        <p><b>1.</b> The User acknowledges that the PIC Client Portal contains information that is commercially sensitive and is, by its nature, confidential to the PIC, its clients and personnel. The User shall take all reasonable precautions to maintain the confidentiality of the information on the PIC Client Portal.</p>
                                        <p><b>2.</b>  The Terms of Use govern the use and security of all information on the PIC Extranet.</p>
                                        <p><b>3.</b> The Terms of Use are applicable to all users of the PIC Client Portal defined as PIC personnel and authorised clients of the PIC.</p>

                                        <p><b>4.</b>  The PIC Client Portal shall be used for lawful purposes only and shall comply with all applicable laws and regulations.</p>

                                        <p><b>5.</b> The PIC Client Portal shall be used for business purposes only and to serve the interests of both the PIC and its clients.</p>

                                        <p><b>6.</b> Users of the PIC Client Portal shall be responsible for any use of and activity on the PIC Client Portal under their unique user credentials.</p>

                                        <p><b>7.</b> Users shall be responsible for safekeeping of their unique user credentials and shall not under any circumstance share their credentials with anyone or use another user’s credentials.</p>

                                        <p><b>8.</b> If an authorised user believes that their password may have been compromised at any time, they shall promptly notify the PIC, upon which the PIC shall have the password changed.</p>

                                        <p><b>9.</b> Users shall not attempt to access any data or programs on the PIC Client Portal for which they do not have authorization or consent. Authorisation and consent can only be granted by the User Line Manager and a duly authorised representative of the PIC.</p>

                                        <p><b>10.</b> The information on this portal is provisional and cannot be deemed to be absolutely accurate, accurate AUM (Assets Under Management) reporting will be provided on a quarterly basis in retrospect.</p>

                                        <p><b>11.</b> Your personal information shall be handled in line with applicable laws and PIC’s data protection policies.</p>


                                        <br><p><b>By making use of this portal, I confirm that I understand and agree to these Terms of Use</b></p>
                                    </div>
                                </div>
                            </section>
                            
                    </div>
                </div>
            </div>
        </ng-content>
    </section>
</main>
</div>
